import { Box, Button, Text, TextInput } from 'grommet';
import { Checkmark } from 'grommet-icons';
import React, { useState } from 'react';
import translate from '../../i18n/translate';
import { amount_init, frais_dossier_init, getFirstPayAmount, promo_init, verifyPromoCode } from '../../services/services';
import { ABONNEMENT, PRODUCT } from '../../services/types';
import { toCurrency } from '../../services/utils';

const rightStyle = {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: 10,
    borderBottomRightRadius: 10,
    border: 'none',
    paddingTop: 0,
    paddingBottom: 0
}
const leftStyle = {
    borderTopLeftRadius: 10,
    borderBottomLeftRadius: 10,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
}
const getReduction = devis => {
    return devis.promo ?
        toCurrency(devis.promo.value) : '';
}

const Promo = ({ devis, onDevisChange, product }) => {

    const [code, setCode] = useState(devis.promo ? devis.promo.code : '');
    const [id, setId] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const verifyCodePromo = () => {
        let promoType = product === PRODUCT.MH ? "MRH en ligne" : 
            product === PRODUCT.MH_TEMPO ? "MRH Tempo en ligne" :
             "PNO en ligne";
        verifyPromoCode(code, promoType)
            .then(res => {
                console.log(res.data);
                let promo = res.data;
                onDevisChange('promo', promo);
                onDevisChange('affiliation', promo.affiliation);
            })
            .catch(err => {
                setErrorMessage(translate('code_invalid'));
                onDevisChange('promo', undefined);
                clearTimeout(id);
                let idTO = setTimeout(() => {
                    setErrorMessage('');
                }, 5000);
                setId(idTO);
            })
    }
    const onKeyUp = event => {
        if (event.keyCode === 13) { // Enter key
            verifyCodePromo();
        }
    }

    let isMonthly = devis.abonnement === ABONNEMENT.monthly;

    return (
        <Box gap="xsmall" style={{ marginTop: 20 }}>
            <Box width="medium" direction="row">
                <TextInput value={code} onKeyUp={onKeyUp} onChange={event => setCode(event.target.value)} style={leftStyle} reverse placeholder={translate('code_promo')} />
                <Button primary style={rightStyle} icon={<Checkmark style={{ cursor: 'pointer' }} onClick={verifyCodePromo} />} />
            </Box>
            {errorMessage &&
                <Text size="small" style={{ color: "#E92C70" }}>{errorMessage}</Text>
            }
            <Box style={{ height: 10 }} />
            <Box justify="between" direction="row">
                <Text size="small">{translate('frais_assurance')} : </Text>
                <Text size="small">{toCurrency(amount_init(devis))}</Text>
            </Box>
            {getReduction(devis) &&
                <Box>
                    <Box justify="between" direction="row">
                        <Text size="small" style={{ color: "#E92C70" }}>Reduction {devis.abonnement === ABONNEMENT.monthly ?  `(${translate('sur')} 12 ${translate('month')})` : ''}: </Text>
                        <Text size="small" style={{ color: "#E92C70" }}>-{getReduction(devis)}</Text>
                    </Box>
                    {devis.abonnement === ABONNEMENT.monthly &&
                        <Box justify="between" direction="row">
                            <Text size="small">({translate('mois_deduit')} :) </Text>
                            <Text size="small">-{toCurrency(promo_init(devis))}</Text>
                        </Box>
                    }
                </Box>
            }
            <Box justify="between" direction="row">
                <Text size="small">{translate('frais_dossier')} : </Text>
                <Text size="small">{toCurrency(frais_dossier_init(devis))}</Text>
            </Box>
            <Box style={{ borderBottom: '2px dashed grey' }} />
            <Box justify="between" direction="row">
                <Text style={{ fontWeight: 'bold' }} size="small">
                    Total :
                </Text>
                <Text style={{ fontWeight: 'bold' }} size="small">
                    {toCurrency(getFirstPayAmount(devis))}
                </Text>
            </Box>
        </Box>
    );
}

export default Promo;